import styled, { css } from 'styled-components';

import { Colors } from 'environment/theme/Colors';
import { generateSpacingOffsets } from 'helpers/cssGenerators';
import { StyleOffsets } from 'types/index';

interface Props {
	disabled?: boolean;
	active?: {
		primary?: boolean;
		vibrantGreen?: boolean;
	};
	paddingOffset?: StyleOffsets;
	marginOffset?: StyleOffsets;
	clickable?: boolean;
}

export const TagWrapper = styled.div<Props>`
	${({ disabled, active, paddingOffset, marginOffset, clickable }) => css`
		border-radius: 0.4rem;
		display: flex;
		align-items: center;
		padding: 0.2rem 0.8rem;
		width: fit-content;
		background-color: ${active?.primary
			? Colors.primary.disabled
			: active?.vibrantGreen
			? Colors.vibrantGreen
			: Colors.background.disabled};

		${disabled &&
		css`
			background-color: ${Colors.background.disabled};
		`};

		${clickable &&
		!disabled &&
		css`
			cursor: pointer;
		`};

		/* SPACING OFFSETS */
		${generateSpacingOffsets({ paddingOffset, marginOffset })}
	`}
`;
